import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportLogApi extends GuiListGeneric {
    constructor() {
        super("LogApi");
    }
}
